import React, { useState } from 'react';
import Modal from '../../../Modal';
import generalMessages from '../../../../messages';
import messages from './messages';

const ModalTimedout = () => {
  const [isOpen, setOpen] = useState(true);

  return (
    <Modal
      actions={[
        {
          content: generalMessages.close,
          name: 'close',
          onClick: () => setOpen(false),
          variant: 'outlined',
        },
      ]}
      content={messages.description}
      open={isOpen}
      title={{
        alt: 'modalTimedOut',
        content: messages.title,
        src: 'modalTimedOut',
      }}
    />
  );
};

export default ModalTimedout;
